import { render, staticRenderFns } from "./OwnerPager.vue?vue&type=template&id=50fc1f32&scoped=true"
import script from "./OwnerPager.vue?vue&type=script&lang=js"
export * from "./OwnerPager.vue?vue&type=script&lang=js"
import style0 from "./OwnerPager.vue?vue&type=style&index=0&id=50fc1f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc1f32",
  null
  
)

export default component.exports